export const rankLabels = [
	'S1',
	'S2',
	'S3',
	'S4',
	'SE',
	'SEM',
	'GN1',
	'GN2',
	'GN3',
	'GN4',
	'MG1',
	'MG2',
	'MGE',
	'DMG',
	'LE',
	'LEM',
	'SMFC',
	'GE',
];
